import type { FaireProductEntity } from "../../entity_types/product";

export const p_efnzy9f57a: FaireProductEntity = {
  token: "p_efnzy9f57a",
  type: "product",
  name: "Healing Power Of Gemstones 72 Pcs. - Closeout .",
  brandToken: "b_6l28vptlbv",
  brandName: "Puka Creations",
  imageUrl:
    "https://cdn.faire.com/fastly/e4cc42fe7ed2eb86e49010f3f2933ee6c77f8daa403a27a1240385f72e59cd4f.webp",
  galleryImageUrls: [],
  priceDollars: 1.39,
  description:
    "💎 Embrace balance and positivity with our Healing Power of Gemstones collection! 🌿💫 Each natural gemstone is thoughtfully selected for its unique energy, believed to promote wellness, clarity, and inner peace. Perfect for meditation, stress relief, or gifting, these stones make a beautiful addition to any home, boutique, or wellness shop. Whether displayed, carried, or gifted, they bring calm, color, and meaning to everyday life. 🕊️💖\n\ntags:\nhealing gemstones, crystal energy stones, natural gemstones, wellness crystals, chakra stones, meditation stones, spiritual healing, gemstone collection, wholesale crystals, mindful gift.",
  tags: [],
  msrpDollars: 3.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:22.159Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
